import config from "../config";

// WebSocketService.js
let socket;

export const getWebSocket = () => {
    if (!socket || socket.readyState === WebSocket.CLOSED) {
        socket = new WebSocket(config.REACT_APP_WEBSOCKET_URL);
        socket.onopen = () => console.log('WebSocket connected');
    }
    return socket;
};
